import React from "react";
import Select from "react-select";

import {
  FORM_SELECT_STYLES,
  NoIndicatorSeparator,
} from "./styles";

export default function SelectCustom({ components, styles, ...props }) {
  return (
    <Select
      menuPortalTarget={document.body}
      components={{
        ...components,
        IndicatorSeparator: NoIndicatorSeparator,
      }}
      styles={{
        ...FORM_SELECT_STYLES,
        ...styles,
      }}
      {...props}
    />
  );
}
